import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { app } from "../../constants/config";
import { fetchingRepayments } from "../../actions/repaymentActions";
import DisplayRepayments from "../Repayments/DisplayRepayments";
import NoRepayments from "../Repayments/NoRepayments";
import AddRepayments from "../Repayments/AddRepayments";

const LandlordRepayment = (props) => {
  useEffect(() => {
    FetchPayment();
  }, [window.location.href.split("/").pop()]);

  const [Loading, setLoading] = useState(false);

  const FetchPayment = () => {
    setLoading(true);
    fetch(`${app}/repayment/landlord`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${props.banker.token}`,
      },
      body: JSON.stringify({
        landlordId: window.location.href.split("/").pop(),
      }),
    })
      .then((res) => res.json())
      .then((details) => {
        setLoading(false);

        if (details.code != 2) {
          props.fetchingRepayments(details);
        } else {
          props.fetchingRepayments([]);
          swal({
            title: "Server Error!",
            text: "Please try again",
            icon: "error",
            timer: 3000,
          });
        }
      })
      .catch((err) => {
        props.fetchingRepayments([]);
        setLoading(false);
        swal({
          title: "Connection Error!",
          text: "Check your connection and try again",
          icon: "error",
          timer: 3000,
        });
      });
  };

  const GetLandlord = (LandlordId) => {
    let landlord = props.Landlords.find(
      (landlord) => (landlord.id = LandlordId)
    );
    return landlord ? landlord : { name: "Unknown" };
  };

  const Status = Loading ? (
    <>
      <p className="text-center">
        <span className="spinner-border text-primary "></span>
      </p>
    </>
  ) : props.Repayments.length > 0 ? (
    <DisplayRepayments />
  ) : (
    <NoRepayments />
  );

  return (
    <div>
      <p className="h6 text-center text-primary">
        <strong>
          {GetLandlord(window.location.href.split("/").pop()).name} Repayments
        </strong>
      </p>
      <AddRepayments></AddRepayments>
      {Status}
    </div>
  );
};

const mapStateToProps = (state) => ({
  banker: state.auth.banker,
  Repayments: state.Repayment.Repayments,
  Landlords: state.Landlord.Landlords,
  Houses: state.House.Houses,
});

export default connect(mapStateToProps, {
  fetchingRepayments,
})(LandlordRepayment);
